import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';

export type JoinClassResult = {
  class_id: string;
  class_name: string;
};

export function useJoinClassByCode(studentId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (inviteCode: string): Promise<JoinClassResult> => {
      const { data, error } = await supabase.rpc('join_class_by_code', {
        p_invite_code: inviteCode.trim().toUpperCase(),
      });
      if (error) throw new Error(error.message);
      const row = (data as Array<{ class_id: string; class_name: string }>)?.[0];
      if (!row) throw new Error('Réponse inattendue du serveur.');
      return row;
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['class-assignments', studentId] });
    },
  });
}
